import React, { useState, useEffect } from 'react';
import './StudentInsights.css';
import { withRouter } from "react-router";
import { PieChart } from 'react-minimal-pie-chart';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { handleException } from "../../app/util/util";
export function StudyCenterStats(props) {
    const classVOList = props.classVOList
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const [overallProgress, setOverallProgress] = useState(null);
    const [classComparison, setClassComparison] = useState(false);
    const [studyDashBoardDetail, setStudyDashBoardDetail] = useState(null);
    const [questionTypeProgress, setQuestionTypeProgress] = useState(null);
    const [totalNumberOfStudents, setTotalNumberOfStudents] = useState(null);
    const [bookLevelProgressList, setBookLevelProgressList] = useState(null);
    const [questionTypeFilter, setQuestionTypeFilter] = useState(["multichoice", "flashcard", "essay", "hypothetical", "issuespotting"]);
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    useEffect(() => {
        getStudyCenterStats();
        getChapterLevelStats();
    }, []);
    const getChapterLevelStats = () => {
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "classVO": { "bookISBN": props.match.params.isbn }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqData)
        };
        fetch(`${localStorage.getItem('ENV')}/manageClassWebService/getStudyDashBoardForProfessorOrStudent`, requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data && data.status === "true") {
                    if (data.studyDashBoardVO) {
                        var totalNumberOfStudents = data.studyDashBoardVO.numberOfEnrolledStudentInClass
                        if (data.studyDashBoardVO.studyDashBoardDetail) {
                            var studyDashBoardDetail = Array.isArray(data.studyDashBoardVO.studyDashBoardDetail) ? data.studyDashBoardVO.studyDashBoardDetail : [data.studyDashBoardVO.studyDashBoardDetail]
                            for (var i = 0; i < studyDashBoardDetail.length; i++) {
                                studyDashBoardDetail[i].learningObjectiveProgressVOList = Array.isArray(studyDashBoardDetail[i].learningObjectiveProgressVOList) ? studyDashBoardDetail[i].learningObjectiveProgressVOList : [studyDashBoardDetail[i].learningObjectiveProgressVOList]
                            }
                            setStudyDashBoardDetail(studyDashBoardDetail); setTotalNumberOfStudents(totalNumberOfStudents);
                        }
                    } else {
                        setOverallProgress(null); setBookLevelProgressList(null);
                    }
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const getStudyCenterStats = () => {
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "classVO": { "bookISBN": props.match.params.isbn }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqData)
        };
        fetch(`${localStorage.getItem('ENV')}/manageClassWebService/getStudyDashBoardForTotalBook`, requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data && data.status === "true") {
                    if (data.studyDashBoardVO && data.studyDashBoardVO.bookLevelProgressList) {
                        var bookLevelProgressList = data.studyDashBoardVO.bookLevelProgressList;
                        var overallProgress = bookLevelProgressList.filter(x => x.qType === "All");
                        var questionTypeProgress = bookLevelProgressList.filter(x => x.qType !== "All");
                        setOverallProgress(overallProgress[0]);
                        setQuestionTypeProgress(questionTypeProgress);
                        setBookLevelProgressList(bookLevelProgressList);
                    } else {
                        setOverallProgress(null); setBookLevelProgressList(null);
                    }
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const expandTopicLink = (e, id) => {
        if (e.currentTarget.innerText == "Expand Topics") {
            e.currentTarget.innerText = "Collapse Topics";
            document.getElementById(id).className = "studyExpandedBlock_rt collapse hide show";
        } else {
            e.currentTarget.innerText = "Expand Topics";
            document.getElementById(id).className = "studyExpandedBlock_rt collapse hide";
        }
    }
    const updateFilter = (e) => {
        var questionTypeFilter = []
        questionTypeFilter.push(document.getElementById("mcqFilter").checked ? "multichoice" : "NA")
        questionTypeFilter.push(document.getElementById("flashcardFilter").checked ? "flashcard" : "NA")
        questionTypeFilter.push(document.getElementById("essayFilter").checked ? "essay" : "NA")
        questionTypeFilter.push(document.getElementById("shortAnsFilter").checked ? "hypothetical" : "NA")
        questionTypeFilter.push(document.getElementById("issueSpottingAnsFilter").checked ? "issuespotting" : "NA")
        setQuestionTypeFilter(questionTypeFilter)
    }
    let studyPieChart = (question) => {
        var studyData = []
        studyData.push({ title: 'correct', value: question.totalCorrectPercentage ? parseInt(question.totalCorrectPercentage) : 0, color: '#85BC20' })
        studyData.push({ title: 'incorrect ', value: question.totalWrongPercentage ? parseInt(question.totalWrongPercentage) : 0, color: '#E5202E' })
        studyData.push({ title: 'needs practice', value: question.totalPartialCorrectPercentage ? parseInt(question.totalPartialCorrectPercentage) : 0, color: '#7FBCE1' })
        studyData.push({ title: 'unanswered', value: question.totalUnAnsweredPercentage ? parseInt(question.totalUnAnsweredPercentage) : 0, color: '#ECECEC' })
        return (<PieChart startAngle={270} lengthAngle={360} lineWidth={35}
            data={studyData}
        />)
    }
    let getQuestionType = (question) => {
        if (question.qType === "MultiChoice")
            return "Multiple Choice"
        else if (question.qType === "flashcard")
            return "Flash Cards"
        else if (question.qType === "ShortAnswers")
            return "Short Answers"
        else if (question.qType === "Essay")
            return "Essay"
        else if (question.qType === "IssueSpotting")
            return "Issue Spotting"
    }
    let studyPieChartClassComparison = (question) => {
        var studyData = []
        studyData.push({ title: 'correct', value: question.totalCorrectPercentageInClass ? parseInt(question.totalCorrectPercentageInClass) : 0, color: '#474747' })
        studyData.push({ title: 'incorrect ', value: question.totalWrongPercentageInClass ? parseInt(question.totalWrongPercentageInClass) : 0, color: '#757575' })
        studyData.push({ title: 'needs practice', value: question.totalPartialCorrectPercentageInClass ? parseInt(question.totalPartialCorrectPercentageInClass) : 0, color: '#BFBFBF' })
        studyData.push({ title: 'unanswered', value: question.totalUnAnsweredPercentageInClass ? parseInt(question.totalUnAnsweredPercentageInClass) : 0, color: '#ECECEC' })
        return (<PieChart startAngle={270} lengthAngle={360} lineWidth={35} data={studyData} />)
    }
    let getTotalQuestionsInChapterLbl = (distinctChapterResponseList) => {
        var totalQuestion = 0
        for (var r = 0; r < distinctChapterResponseList.length; r++) {
            totalQuestion += distinctChapterResponseList[r].totalQuestions ? parseInt(distinctChapterResponseList[r].totalQuestions) : 0;
        }
        return <span className="studyChapterList mBottomFive"> {totalQuestion > 1 ? totalQuestion + " Questions" : totalQuestion + " Question"} </span>;
    }
    let getTotalQuestionsInChapter = (distinctChapterResponseList) => {
        var totalQuestion = 0
        for (var r = 0; r < distinctChapterResponseList.length; r++) {
            totalQuestion += distinctChapterResponseList[r].totalQuestions ? parseInt(distinctChapterResponseList[r].totalQuestions) : 0;
        }
        return totalQuestion;
    }
    let chapterLevelProgressBar = (chapterVO) => {
        let distinctChapterResponseList = chapterVO.distinctChapterResponseList;
        var totalQuestion = 0, totalCorrectAns = 0, totalWrongAns = 0, totalPartialAns = 0, totalUnans = 0;
        for (var r = 0; r < distinctChapterResponseList.length; r++) {
            if (distinctChapterResponseList[r] && questionTypeFilter.includes(distinctChapterResponseList[r].questionType)) {
                totalCorrectAns += distinctChapterResponseList[r].totalCorrectAnswerByLoggedinStudent ? parseInt(distinctChapterResponseList[r].totalCorrectAnswerByLoggedinStudent) : 0;
                totalWrongAns += distinctChapterResponseList[r].totalWrongAnswerByLoggedinStudent ? parseInt(distinctChapterResponseList[r].totalWrongAnswerByLoggedinStudent) : 0;
                totalPartialAns += distinctChapterResponseList[r].totalPartialCorrectAnswerByLoggedinStudent ? parseInt(distinctChapterResponseList[r].totalPartialCorrectAnswerByLoggedinStudent) : 0;
                totalQuestion += distinctChapterResponseList[r].totalQuestions ? parseInt(distinctChapterResponseList[r].totalQuestions) : 0;
                totalUnans += distinctChapterResponseList[r].totalUnAnsweredByLoggedinStudent ? parseInt(distinctChapterResponseList[r].totalUnAnsweredByLoggedinStudent) : 0;
            }
        }
        //CAlculation logic - after  11/25  - HS
        var totalCorrectPercentage = decimailFormat(((totalCorrectAns) / (totalQuestion)) * 100)
        var totalInCorrectPercentage = decimailFormat(((totalWrongAns) / (totalQuestion)) * 100)
        var totalPartialPercentage = decimailFormat(((totalPartialAns) / (totalQuestion)) * 100)
        var totalUnAnsPercentage = decimailFormat(((totalUnans) / (totalQuestion)) * 100)
        return (
            <div>
                <ProgressBar className="chapterTopicProgress">
                    <ProgressBar className="progress-greenColor insightsOverAllProgress" aria-label={`${chapterVO.navbarTitle}: my correctly answered questions percentage`} now={totalCorrectPercentage ? totalCorrectPercentage : 0} />
                    <ProgressBar className="progress-redColor insightsOverAllProgress" aria-label={`${chapterVO.navbarTitle}: my incorrectly answered questions percentage`} now={totalInCorrectPercentage ? totalInCorrectPercentage : 0} />
                    <ProgressBar className="progress-blueColor insightsOverAllProgress" aria-label={`${chapterVO.navbarTitle}: my practice needed questions percentage`} now={totalPartialPercentage ? totalPartialPercentage : 0} />
                    <ProgressBar className="progress-greyColor insightsOverAllProgress" aria-label={`${chapterVO.navbarTitle}: my unanswered questions percentage`} now={totalUnAnsPercentage ? totalUnAnsPercentage : 0} />
                </ProgressBar>
                <div className="insightProperty mTopFive mBottomTen">
                    <span>My Progress: {isNaN(totalCorrectPercentage) ? 0 : totalCorrectPercentage}% Correct</span> <span className="pipeLine_rt">|</span>
                    <span>{isNaN(totalInCorrectPercentage) ? 0 : totalInCorrectPercentage}% Incorrect</span> <span className="pipeLine_rt">|</span>
                    <span>{isNaN(totalPartialPercentage) ? 0 : totalPartialPercentage}% Needs practice</span> <span className="pipeLine_rt">|</span>
                    <span>{isNaN(totalUnAnsPercentage) ? 0 : totalUnAnsPercentage}% Unanswered</span>
                </div>
            </div>
        )
    }
    let chapterLevelClassProgressBar = (chapterVO) => {
        let distinctChapterResponseList = chapterVO.distinctChapterResponseList;
        var totalQuestion = 0, totalCorrectAns = 0, totalWrongAns = 0, totalPartialAns = 0, totalUnans = 0;
        var totalCorrectPercentage = 0, totalInCorrectPercentage = 0, totalPartialPercentage = 0, totalUnAnsPercentage = 0;
        // calculation logic - after 11/25  HS
        // Here for Class total both Loggedinuser and Other user data is added and the Average % is taken
        for (var r = 0; r < distinctChapterResponseList.length; r++) {
            if (distinctChapterResponseList[r] && questionTypeFilter.includes(distinctChapterResponseList[r].questionType)) {
                totalCorrectAns += distinctChapterResponseList[r].totalCorrectAnswer && distinctChapterResponseList[r].totalCorrectAnswerByLoggedinStudent ? parseInt(distinctChapterResponseList[r].totalCorrectAnswer) + parseInt(distinctChapterResponseList[r].totalCorrectAnswerByLoggedinStudent) : 0;
                totalWrongAns += distinctChapterResponseList[r].totalWrongAnswer && distinctChapterResponseList[r].totalWrongAnswerByLoggedinStudent ? parseInt(distinctChapterResponseList[r].totalWrongAnswer) + parseInt(distinctChapterResponseList[r].totalWrongAnswerByLoggedinStudent) : 0;
                totalPartialAns += distinctChapterResponseList[r].totalPartialCorrect && distinctChapterResponseList[r].totalPartialCorrectAnswerByLoggedinStudent ? parseInt(distinctChapterResponseList[r].totalPartialCorrect) + parseInt(distinctChapterResponseList[r].totalPartialCorrectAnswerByLoggedinStudent) : 0;
                totalQuestion += distinctChapterResponseList[r].totalQuestions ? parseInt(distinctChapterResponseList[r].totalQuestions) : 0;
                if (totalNumberOfStudents !== undefined && totalNumberOfStudents !== null && parseInt(totalNumberOfStudents) > 0) {
                    totalUnans += distinctChapterResponseList[r].totalUnAnswered && distinctChapterResponseList[r].totalUnAnsweredByLoggedinStudent ? parseInt(distinctChapterResponseList[r].totalUnAnswered) + parseInt(distinctChapterResponseList[r].totalUnAnsweredByLoggedinStudent) : 0;
                }
                else {
                    totalUnans += distinctChapterResponseList[r].totalUnAnsweredByLoggedinStudent ? parseInt(distinctChapterResponseList[r].totalUnAnsweredByLoggedinStudent) : 0;
                }
            }
        }
        // CAlculation logic - after 11/25  HS
        if (totalNumberOfStudents !== undefined && totalNumberOfStudents !== null &&
            parseInt(totalNumberOfStudents) > 0) {
            totalCorrectPercentage = decimailFormat(((totalCorrectAns) / (totalQuestion * parseInt(totalNumberOfStudents))) * 100)
            totalInCorrectPercentage = decimailFormat(((totalWrongAns) / (totalQuestion * parseInt(totalNumberOfStudents))) * 100)
            totalPartialPercentage = decimailFormat(((totalPartialAns) / (totalQuestion * parseInt(totalNumberOfStudents))) * 100)
            totalUnAnsPercentage = decimailFormat(((totalUnans) / (totalQuestion * parseInt(totalNumberOfStudents))) * 100)
        } else {
            totalCorrectPercentage = decimailFormat(((totalCorrectAns) / (totalQuestion)) * 100)
            totalInCorrectPercentage = decimailFormat(((totalWrongAns) / (totalQuestion)) * 100)
            totalPartialPercentage = decimailFormat(((totalPartialAns) / (totalQuestion)) * 100)
            totalUnAnsPercentage = decimailFormat(((totalUnans) / (totalQuestion)) * 100)
        }
        return (
            <div>
                <ProgressBar className="chapterTopicProgress">
                    <ProgressBar className="progress-darkGrayColor insightsOverAllProgress" aria-label={`${chapterVO.navbarTitle}: class’s correctly answered questions percentage`} now={totalCorrectPercentage ? totalCorrectPercentage : 0} />
                    <ProgressBar className="progress-mildGrayColor insightsOverAllProgress" aria-label={`${chapterVO.navbarTitle}: class’s incorrectly answered questions percentage`} now={totalInCorrectPercentage ? totalInCorrectPercentage : 0} />
                    <ProgressBar className="progress-lightGray insightsOverAllProgress" aria-label={`${chapterVO.navbarTitle}: class’s practice needed questions percentage`} now={totalPartialPercentage ? totalPartialPercentage : 0} />
                    <ProgressBar className="progress-greyColor insightsOverAllProgress" aria-label={`${chapterVO.navbarTitle}: class’s unanswered questions percentage`} now={totalUnAnsPercentage ? totalUnAnsPercentage : 0} />
                </ProgressBar>
                <div className="insightProperty mTopFive">
                    <span>Class Progress: {isNaN(totalCorrectPercentage) ? 0 : totalCorrectPercentage}% Correct</span> <span className="pipeLine_rt">|</span>
                    <span>{isNaN(totalInCorrectPercentage) ? 0 : totalInCorrectPercentage}% Incorrect</span> <span className="pipeLine_rt">|</span>
                    <span>{isNaN(totalPartialPercentage) ? 0 : totalPartialPercentage}% Needs practice</span> <span className="pipeLine_rt">|</span>
                    <span>{isNaN(totalUnAnsPercentage) ? 0 : totalUnAnsPercentage}% Unanswered</span>
                </div>
            </div>
        )
    }
    let getLoProgress = (learningObj) => {
        let learningObjectiveResponseList = learningObj.learningObjectiveResponseList;
        var totalQuestion = 0, totalCorrectAns = 0, totalWrongAns = 0, totalPartialAns = 0, totalUnans = 0;
        for (var r = 0; r < learningObjectiveResponseList.length; r++) {
            if (learningObjectiveResponseList[r] && questionTypeFilter.includes(learningObjectiveResponseList[r].questionType)) {
                totalCorrectAns += learningObjectiveResponseList[r].totalCorrectAnswerByLoggedinStudent ? parseInt(learningObjectiveResponseList[r].totalCorrectAnswerByLoggedinStudent) : 0;
                totalWrongAns += learningObjectiveResponseList[r].totalWrongAnswerByLoggedinStudent ? parseInt(learningObjectiveResponseList[r].totalWrongAnswerByLoggedinStudent) : 0;
                totalPartialAns += learningObjectiveResponseList[r].totalPartialCorrectAnswerByLoggedinStudent ? parseInt(learningObjectiveResponseList[r].totalPartialCorrectAnswerByLoggedinStudent) : 0;
                totalQuestion += learningObjectiveResponseList[r].totalQuestions ? parseInt(learningObjectiveResponseList[r].totalQuestions) : 0;
                totalUnans += learningObjectiveResponseList[r].totalUnAnsweredByLoggedinStudent ? parseInt(learningObjectiveResponseList[r].totalUnAnsweredByLoggedinStudent) : 0;
            }
        }
        // CAlculation logic - after 11/25  HS
        var totalCorrectPercentage = decimailFormat((((totalCorrectAns) / (totalQuestion)) * 100))
        var totalInCorrectPercentage = decimailFormat((((totalWrongAns) / (totalQuestion)) * 100))
        var totalPartialPercentage = decimailFormat((((totalPartialAns) / (totalQuestion)) * 100))
        var totalUnAnsPercentage = decimailFormat((((totalUnans) / (totalQuestion)) * 100))
        return (
            <div>
                <span className="mBottomFive qustionCount_rt">{totalQuestion} questions</span>
                <div className="multicolor-bar">
                    <ProgressBar className="chapterTopicProgress">
                        <ProgressBar className="progress-greenColor insightsOverAllProgress" aria-label={`${learningObj.learningObjName}: my correctly answered questions percentage`} now={totalCorrectPercentage ? totalCorrectPercentage : 0} />
                        <ProgressBar className="progress-redColor insightsOverAllProgress" aria-label={`${learningObj.learningObjName}: my incorrectly answered questions percentage`} now={totalInCorrectPercentage ? totalInCorrectPercentage : 0} />
                        <ProgressBar className="progress-blueColor insightsOverAllProgress" aria-label={`${learningObj.learningObjName}: my practice needed questions percentage`} now={totalPartialPercentage ? totalPartialPercentage : 0} />
                        <ProgressBar className="progress-greyColor insightsOverAllProgress" aria-label={`${learningObj.learningObjName}: my unanswered questions percentage`} now={totalUnAnsPercentage ? totalUnAnsPercentage : 0} />
                    </ProgressBar>
                </div>
                <div className="insightProperty mTopFive">
                    <span>My Progress: {totalCorrectPercentage ? totalCorrectPercentage : 0}% Correct</span> <span className="pipeLine_rt">|</span>
                    <span>{totalInCorrectPercentage ? totalInCorrectPercentage : 0}% Incorrect</span> <span className="pipeLine_rt">|</span>
                    <span>{totalPartialPercentage ? totalPartialPercentage : 0}% Needs practice</span> <span className="pipeLine_rt">|</span>
                    <span>{totalUnAnsPercentage ? totalUnAnsPercentage : 0}% Unanswered</span>
                </div>
            </div>
        )
    }
    let getClassLoProgress = (learningObj) => {
        let learningObjectiveResponseList = learningObj.learningObjectiveResponseList;
        var totalQuestion = 0, totalCorrectAns = 0, totalWrongAns = 0, totalPartialAns = 0, totalUnans = 0;
        var totalCorrectPercentage = 0, totalInCorrectPercentage = 0, totalPartialPercentage = 0, totalUnAnsPercentage = 0;
        // calculation logic - after 11/25  HS
        // Here for Class total both Loggedinuser and Other user data is added and the Average % is taken
        for (var r = 0; r < learningObjectiveResponseList.length; r++) {
            if (learningObjectiveResponseList[r] && questionTypeFilter.includes(learningObjectiveResponseList[r].questionType)) {
                totalCorrectAns += learningObjectiveResponseList[r].totalCorrectAnswer && learningObjectiveResponseList[r].totalCorrectAnswerByLoggedinStudent ? parseInt(learningObjectiveResponseList[r].totalCorrectAnswer) + parseInt(learningObjectiveResponseList[r].totalCorrectAnswerByLoggedinStudent) : 0;
                totalWrongAns += learningObjectiveResponseList[r].totalWrongAnswer && learningObjectiveResponseList[r].totalWrongAnswerByLoggedinStudent ? parseInt(learningObjectiveResponseList[r].totalWrongAnswer) + parseInt(learningObjectiveResponseList[r].totalWrongAnswerByLoggedinStudent) : 0;
                totalPartialAns += learningObjectiveResponseList[r].totalPartialCorrect && learningObjectiveResponseList[r].totalPartialCorrectAnswerByLoggedinStudent ? parseInt(learningObjectiveResponseList[r].totalPartialCorrect) + parseInt(learningObjectiveResponseList[r].totalPartialCorrectAnswerByLoggedinStudent) : 0;
                totalQuestion += learningObjectiveResponseList[r].totalQuestions ? parseInt(learningObjectiveResponseList[r].totalQuestions) : 0;
                if (totalNumberOfStudents !== undefined && totalNumberOfStudents !== null && parseInt(totalNumberOfStudents) > 0) {
                    totalUnans += learningObjectiveResponseList[r].totalUnAnswered && learningObjectiveResponseList[r].totalUnAnsweredByLoggedinStudent ? parseInt(learningObjectiveResponseList[r].totalUnAnswered) + parseInt(learningObjectiveResponseList[r].totalUnAnsweredByLoggedinStudent) : 0;
                }
                else {
                    totalUnans += learningObjectiveResponseList[r].totalUnAnsweredByLoggedinStudent ? parseInt(learningObjectiveResponseList[r].totalUnAnsweredByLoggedinStudent) : 0;
                }
            }
        }
        // calculation logic - after 11/25  HS
        if (totalNumberOfStudents !== undefined && totalNumberOfStudents !== null &&
            parseInt(totalNumberOfStudents) > 0) {
            totalCorrectPercentage = decimailFormat(((totalCorrectAns) / (totalQuestion * parseInt(totalNumberOfStudents))) * 100)
            totalInCorrectPercentage = decimailFormat(((totalWrongAns) / (totalQuestion * parseInt(totalNumberOfStudents))) * 100)
            totalPartialPercentage = decimailFormat(((totalPartialAns) / (totalQuestion * parseInt(totalNumberOfStudents))) * 100)
            totalUnAnsPercentage = decimailFormat(((totalUnans) / (totalQuestion * parseInt(totalNumberOfStudents))) * 100)
        } else {
            totalCorrectPercentage = decimailFormat(((totalCorrectAns) / (totalQuestion)) * 100)
            totalInCorrectPercentage = decimailFormat(((totalWrongAns) / (totalQuestion)) * 100)
            totalPartialPercentage = decimailFormat(((totalPartialAns) / (totalQuestion)) * 100)
            totalUnAnsPercentage = decimailFormat(((totalUnans) / (totalQuestion)) * 100)
        }
        return (
            <div>
                <div className="multicolor-bar">
                    <ProgressBar className="chapterTopicProgress">
                        <ProgressBar className="progress-darkGrayColor insightsOverAllProgress" aria-label={`${learningObj.learningObjName}: class’s correctly answered questions percentage`} now={totalCorrectPercentage ? totalCorrectPercentage : 0} />
                        <ProgressBar className="progress-mildGrayColor insightsOverAllProgress" aria-label={`${learningObj.learningObjName}: class’s incorrectly answered questions percentage`} now={totalInCorrectPercentage ? totalInCorrectPercentage : 0} />
                        <ProgressBar className="progress-lightGray insightsOverAllProgress" aria-label={`${learningObj.learningObjName}: class’s practice needed questions percentage`} now={totalPartialPercentage ? totalPartialPercentage : 0} />
                        <ProgressBar className="progress-greyColor insightsOverAllProgress" aria-label={`${learningObj.learningObjName}: class’s unanswered questions percentage`} now={totalUnAnsPercentage ? totalUnAnsPercentage : 0} />
                    </ProgressBar>
                </div>
                <div className="insightProperty mTopFive">
                    <span>Class Progress: {totalCorrectPercentage ? totalCorrectPercentage : 0}% Correct</span> <span className="pipeLine_rt">|</span>
                    <span>{totalInCorrectPercentage ? totalInCorrectPercentage : 0}% Incorrect</span> <span className="pipeLine_rt">|</span>
                    <span>{totalPartialPercentage ? totalPartialPercentage : 0}% Needs practice</span> <span className="pipeLine_rt">|</span>
                    <span>{totalUnAnsPercentage ? totalUnAnsPercentage : 0}% Unanswered</span>
                </div>
            </div>
        )
    }
    let decimailFormat = (value) => {
        if (!isNaN(value))
            return parseFloat(value % 1 === 0 ? Math.round(value) : value.toFixed(2))
    }
    const handleFilterType = (e, id) => {
        if (e.key === 'Enter') {
            document.getElementById(id).click();
        }
    }
    const handleExpandTopicLink = (e, id) => {
        if (e.key === 'Enter') {
            expandTopicLink(e, id);
        }
    }
    const handleClassComparison = (e) => {
        if (e.key === 'Enter') {
            setClassComparison(!classComparison);
        }
    }
    return (
        <div>
            <div className="mTopTwnty mBottomTen d-flex">
                <div className="col pText no-padding" style={{ paddingLeft: '0' }}>Check your progress to understand your strengths and weaknesses.</div>
            </div>
            {
                classVOList ?
                    <div className="mBottomTen">
                        {
                            classComparison == true ?
                                <i data-testid="class_comparison_on" className="fa fa-toggle-on" role='button' aria-pressed="true" aria-label='Toggle Switch for Class Comparison' onClick={() => setClassComparison(false)}></i>
                                :
                                <i data-testid="class_comparison_off" className="fa fa-toggle-off" role='button' aria-pressed="false" aria-label='Toggle Switch for Class Comparison' onClick={() => setClassComparison(true)}></i>
                        }
                        <span className="iconText" tabIndex="0" onKeyDown={(e) => handleClassComparison(e)}> Class Comparison</span>
                    </div>
                    : null
            }
            <div className="mainDiv">
                <div className="propertyFallDiv">
                    <span className="fallText16">Overall Progress</span>
                </div>
                {overallProgress ?
                    <div className="" style={{ padding: '10px' }}>
                        {classComparison ? <div className="insightHeading">My Progress</div> : null}
                        <span className="qustionCount_rt">{overallProgress ? overallProgress.totalQuestions : null} Questions</span>
                        <div className="multicolor-bar">
                            <ProgressBar className="insightsOverAllProgressContainer">
                                <ProgressBar className="progress-greenColor insightsOverAllProgress" aria-label='My overall correctly answered questions percentage' now={overallProgress.totalCorrectPercentage ? overallProgress.totalCorrectPercentage : 0} />
                                <ProgressBar className="progress-redColor insightsOverAllProgress" aria-label='My overall incorrectly answered questions percentage' now={overallProgress.totalWrongPercentage ? overallProgress.totalWrongPercentage : 0} />
                                <ProgressBar className="progress-blueColor insightsOverAllProgress" aria-label='My overall practice needed questions percentage' now={overallProgress.totalPartialCorrectPercentage ? overallProgress.totalPartialCorrectPercentage : 0} />
                                <ProgressBar className="progress-greyColor insightsOverAllProgress" aria-label='My overall unanswered questions percentage' now={overallProgress.totalUnAnsweredPercentage ? overallProgress.totalUnAnsweredPercentage : 0} />
                            </ProgressBar>
                        </div>
                        <span className="insightProperty mtopFive">
                            <div className="value">
                                <span><span>{overallProgress.totalCorrectPercentage ? overallProgress.totalCorrectPercentage : 0}</span>% Correct</span>
                                <span className="pipeLine_rt">|</span>
                                <span><span>{overallProgress.totalWrongPercentage ? overallProgress.totalWrongPercentage : 0}</span>% Incorrect</span>
                                <span className="pipeLine_rt">|</span>
                                <span><span>{overallProgress.totalPartialCorrectPercentage ? overallProgress.totalPartialCorrectPercentage : 0}</span>% Needs practice</span>
                                <span className="pipeLine_rt">|</span>
                                <span><span>{overallProgress.totalUnAnsweredPercentage ? overallProgress.totalUnAnsweredPercentage : 0}</span>% Unanswered</span>
                            </div>
                        </span>
                    </div>
                    : null}
                {classComparison ?
                    <div className="classComparisonAvg" style={{ padding: '10px' }}>
                        <div className="insightHeading">Class Average</div>
                        <span className="qustionCount_rt">{overallProgress ? overallProgress.totalQuestions : null} Questions</span>
                        <div className="multicolor-bar multiDarkcolor-bar">
                            <ProgressBar className="insightsOverAllProgressContainer classComparisonProgress">
                                <ProgressBar className="progress-darkGrayColor insightsOverAllProgress" aria-label='Class overall correctly answered questions percentage' now={overallProgress && overallProgress.totalCorrectPercentageInClass ? overallProgress.totalCorrectPercentageInClass : 0} />
                                <ProgressBar className="progress-mildGrayColor insightsOverAllProgress" aria-label='Class overall incorrectly answered questions percentage' now={overallProgress && overallProgress.totalWrongPercentageInClass ? overallProgress.totalWrongPercentageInClass : 0} />
                                <ProgressBar className="progress-lightGray insightsOverAllProgress" aria-label='Class overall practice needed questions percentage' now={overallProgress && overallProgress.totalPartialCorrectPercentageInClass ? overallProgress.totalPartialCorrectPercentageInClass : 0} />
                                <ProgressBar className="progress-greyColor insightsOverAllProgress" aria-label='Class overall unanswered questions percentage' now={overallProgress && overallProgress.totalUnAnsweredPercentageInClass ? overallProgress.totalUnAnsweredPercentageInClass : 0} />
                            </ProgressBar>
                        </div>
                        <span className="insightProperty mtopFive">
                            <div className="value">
                                <span>{overallProgress && overallProgress.totalCorrectPercentageInClass ? overallProgress.totalCorrectPercentageInClass : 0}% Correct</span>
                                <span className="pipeLine_rt">|</span>
                                <span>{overallProgress && overallProgress.totalWrongPercentageInClass ? overallProgress.totalWrongPercentageInClass : 0}% Incorrect</span>
                                <span className="pipeLine_rt">|</span>
                                <span>{overallProgress && overallProgress.totalPartialCorrectPercentageInClass ? overallProgress.totalPartialCorrectPercentageInClass : 0}% Needs practice</span>
                                <span className="pipeLine_rt">|</span>
                                <span>{overallProgress && overallProgress.totalUnAnsweredPercentageInClass ? overallProgress.totalUnAnsweredPercentageInClass : 0}% Unanswered</span>
                            </div>
                        </span>
                    </div> : null}
            </div>
            <div className="mainDiv mTopTwnty">
                <div className="propertyFallDiv">
                    <span className="fallText16">Question Type Progress</span>
                </div>
                <div className="" style={{ padding: '10px' }}>
                    <div className="practiceSection">
                        <span className="insightHeading">Practice</span>
                        <br />  <br />
                        <div className="col-lg-12 row cusorPointer">
                            {questionTypeProgress ? questionTypeProgress.map((question, index) => (
                                parseInt(question.totalQuestions) > 0 ?
                                    <div className="col-lg-3" style={{ textAlign: 'center' }}>
                                        <span className="insightProperty">{getQuestionType(question)}<br />
                                            <span>{question.totalQuestions} questions</span></span>
                                        <div aria-hidden='true' style={{ width: '5rem', margin: 'auto' }}>
                                            {studyPieChart(question)}
                                        </div>
                                        <span className="insightProperty">
                                            {question.totalCorrectPercentage ? parseFloat(question.totalCorrectPercentage).toFixed(2) : 0}% correct <br />
                                            {question.totalWrongPercentage ? parseFloat(question.totalWrongPercentage).toFixed(2) : 0}% incorrect <br />
                                            {question.totalPartialCorrectPercentage ? parseFloat(question.totalPartialCorrectPercentage).toFixed(2) : 0}% needs practice <br />
                                            {question.totalUnAnsweredPercentage ? parseFloat(question.totalUnAnsweredPercentage).toFixed(2) : 0}% unanswered
                                        </span>
                                    </div> : null
                            )) : null}
                        </div>
                        {classComparison ?
                            <div className="classComparisonAvg">
                                <div className="insightHeading mTopTwnty">Class Average</div>
                                <br />  <br />
                                <div className="col-lg-12 row cusorPointer">
                                    {questionTypeProgress ? questionTypeProgress.map((question, index) => (
                                        parseInt(question.totalQuestions) > 0 ?
                                            <div className="col" style={{ textAlign: 'center' }}>
                                                <span className="insightProperty"> {getQuestionType(question)} <br />
                                                    <span>{question.totalQuestions} questions</span></span>
                                                <div aria-hidden='true' style={{ width: '5rem', margin: 'auto' }}>
                                                    {studyPieChartClassComparison(question)}
                                                </div>
                                                <span className="insightProperty">
                                                    {question.totalCorrectPercentageInClass ? parseFloat(question.totalCorrectPercentageInClass).toFixed(2) : 0}% correct <br />
                                                    {question.totalWrongPercentageInClass ? parseFloat(question.totalWrongPercentageInClass).toFixed(2) : 0}% incorrect <br />
                                                    {question.totalPartialCorrectPercentageInClass ? parseFloat(question.totalPartialCorrectPercentageInClass).toFixed(2) : 0}% needs practice <br />
                                                    {question.totalUnAnsweredPercentageInClass ? parseFloat(question.totalUnAnsweredPercentageInClass).toFixed(2) : 0}% unanswered
                                                </span>
                                            </div> : null
                                    )) : null}
                                </div>
                            </div>
                            : null}
                        <br />
                    </div>
                </div>
            </div>
            <div className="mainDiv mTopTwnty">
                <div className="propertyFallDiv d-flex">
                    <div className="fallText16" style={{ width: '100%' }}>Chapter and Topic Progress</div>
                    <div id="filterRt_Id" className="dropdown">
                        <div className="fallText16 pull-right dropdown-toggle" href="#" role="button"
                            id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" tabIndex="0">
                            Filters
                        </div>
                        <ul className="dropdown-menu filterRt_Listers" aria-labelledby="dropdownMenuLink">
                            <li className="dropdown-item">
                                <a className="listChoiceFilter" data-value="multipleChoice" tabIndex="-1">
                                    <input data-testid="mcqFilter" type="checkbox" role="checkbox" aria-label="Multiple Choice" id="mcqFilter" defaultChecked="true" onKeyDown={(e) => handleFilterType(e, "mcqFilter")} />
                                    <span className="mLeftFive">Multiple Choice</span>
                                </a>
                            </li>
                            <li className="dropdown-item">
                                <a className="listChoiceFilter" data-value="flshCards" tabIndex="-1">
                                    <input data-testid="flashcardFilter" type="checkbox" role="checkbox" aria-label="Flash Cards" id="flashcardFilter" defaultChecked="true" onKeyDown={(e) => handleFilterType(e, "flashcardFilter")} />
                                    <span className="mLeftFive">Flash Cards</span>
                                </a>
                            </li>
                            <li className="dropdown-item">
                                <a className="listChoiceFilter" data-value="shortAnswer" tabIndex="-1">
                                    <input data-testid="shortAnsFilter" type="checkbox" role="checkbox" aria-label="Short Answer" id="shortAnsFilter" defaultChecked="true" onKeyDown={(e) => handleFilterType(e, "shortAnsFilter")} />
                                    <span className="mLeftFive">Short Answer</span>
                                </a>
                            </li>
                            <li className="dropdown-item">
                                <a className="listChoiceFilter" data-value="issueSpotting" tabIndex="-1">
                                    <input data-testid="issueSpottingAnsFilter" type="checkbox" role="checkbox" aria-label="Issue Spotting" id="issueSpottingAnsFilter" defaultChecked="true" onKeyDown={(e) => handleFilterType(e, "issueSpottingAnsFilter")} />
                                    <span className="mLeftFive">Issue Spotting</span>
                                </a>
                            </li>
                            <li className="dropdown-item">
                                <a className="listChoiceFilter" data-value="essay" tabIndex="-1">
                                    <input data-testid="essayFilter" type="checkbox" role="checkbox" aria-label="Essay" id="essayFilter" defaultChecked="true" onKeyDown={(e) => handleFilterType(e, "essayFilter")} />
                                    <span className="mLeftFive">Essay</span>
                                </a>
                            </li>
                            <li className="dropdown-item">
                                <div className="mTopTwnty">
                                    <button type="submit" title="Save" className="saveBtn_rt" onClick={updateFilter}>Save</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                {studyDashBoardDetail ? studyDashBoardDetail.map((dashboard, index) => (
                    <div>
                        {getTotalQuestionsInChapter(dashboard.chapterVO.distinctChapterResponseList) > 0 ?
                            <div className="chapterSection">
                                <div className="mBottomTen" style={{ padding: '10px' }}>
                                    <div className="studyChapterList mBottomFive ">Chapter {dashboard.chapterVO.chapterNumber}: {dashboard.chapterVO.chapterTitle}</div>
                                    <div> {getTotalQuestionsInChapterLbl(dashboard.chapterVO.distinctChapterResponseList)} </div>
                                    <div className="multicolor-bar">
                                        {chapterLevelProgressBar(dashboard.chapterVO)}
                                    </div>
                                    {classComparison ?
                                        <div className="multicolor-bar">
                                            {chapterLevelClassProgressBar(dashboard.chapterVO)}
                                        </div>
                                        : null}
                                    <div className="expandTopics_rt mTopTen"
                                        onClick={(e) => expandTopicLink(e, "insideExpandTopicsId_" + index)}
                                    ><span tabIndex="0" onKeyDown={(e) => handleExpandTopicLink(e, "insideExpandTopicsId_" + index)}>Expand Topics</span></div>
                                </div>
                                <div id={"insideExpandTopicsId_" + index} className="studyExpandedBlock_rt collapse hide">
                                    {dashboard.learningObjectiveProgressVOList ? dashboard.learningObjectiveProgressVOList.map((learningObj, loIndex) => (
                                        <div className="mLeftThirty mTopTen mBottomFifteen expandedChapterList">
                                            <div className="studyChapterList">{learningObj.learningObjName}</div>
                                            {getLoProgress(learningObj)}
                                            {classComparison ? <div className="classComparisonAvg">{getClassLoProgress(learningObj)}</div> : null}
                                        </div>
                                    )) : null}
                                </div>
                                <div className="clearfix mTopTen mBottomTen borderBottom"></div>
                            </div> : null}
                    </div>
                )) : null}
            </div>
        </div>
    )
}
export default withRouter(StudyCenterStats);
